import styled from 'styled-components';
import { Text } from 'common/common-components.styled';

export const StyledFileName = styled(Text)`
  word-break: break-all;
`;
